import React from 'react'
import { Modal } from 'antd'
import PropTypes from 'prop-types'

import { MarkMiscTaskAsVerifiedForm } from '../../forms'

const MarkMiscTaskAsVerifiedModal = ({
  isModalOpen,
  isQCVerified,
  comment,
  onSubmit,
  closeModal,
}) => {
  const title = isQCVerified
    ? 'Mark miscellaneous task as QC verified'
    : 'Mark miscellaneous task as verified'

  return (
    <Modal title={title} visible={isModalOpen} footer={null}>
      <MarkMiscTaskAsVerifiedForm
        isModalOpen={isModalOpen}
        comment={comment}
        onSubmit={onSubmit}
        onClose={closeModal}
      />
    </Modal>
  )
}

MarkMiscTaskAsVerifiedModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  isQCVerified: PropTypes.bool.isRequired,
  comment: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
}

MarkMiscTaskAsVerifiedModal.defaultProps = {
  comment: '',
}

export default MarkMiscTaskAsVerifiedModal
